module.exports = __webpack_public_path__ + "img/analyse.202b2a07.jpg";